// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  returns: {
    name: 'returns',
    componentName: 'Returns',
    chunk: () =>
      import(
        /* webpackChunkName: "returns" */
        './pages/Returns'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Returns'))
            .Returns
        : currentRouteName === 'returns'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Returns,
            })),
          );
    },
    path: '/:context?/myaccount/start-a-return',
    prefetch: [],
    channel: null,
  },
  returnSummary: {
    name: 'returnSummary',
    componentName: 'ReturnSummaryPage',
    chunk: () =>
      import(
        /* webpackChunkName: "returnSummary" */
        './pages/ReturnSummaryPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/ReturnSummaryPage'),
          ).ReturnSummaryPage
        : currentRouteName === 'returnSummary'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ReturnSummaryPage,
            })),
          );
    },
    path: '/:context?/myaccount/return-summary',
    prefetch: [],
    channel: null,
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () =>
      import(
        /* webpackChunkName: "home" */
        './pages/Home'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home')).Home
        : currentRouteName === 'home'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Home })),
          );
    },
    path: '/:context?/',
    channel: null,
  },
});
